export {
  createReportHeatmapBundle as createReportHeatmapCanvasBundle,
  createReportHeatmapDescriptor as createReportHeatmapCanvasDescriptor,
  hashReportHeatmapDescriptor as hashReportHeatmapCanvasDescriptor,
  renderReportHeatmapBundle as renderReportHeatmapCanvasBundle,
  renderReportHeatmapHeatmapCanvas,
  renderReportHeatmapLegendCanvas,
} from '../heatmapCanvas'

export type {
  ReportHeatmapAxisMetadata,
  ReportHeatmapCanvas,
  ReportHeatmapCanvasContext,
  ReportHeatmapCanvasFactory,
  ReportHeatmapCdfMetadata,
  ReportHeatmapColorStop,
  ReportHeatmapDescriptor as ReportHeatmapCanvasDescriptor,
  ReportHeatmapDescriptorInput as ReportHeatmapCanvasDescriptorInput,
  ReportHeatmapRenderOptions,
  ReportHeatmapValueScaleMetadata,
} from '../heatmapCanvas'

export {
  createReportHeatmapDescriptor,
  hashReportHeatmapDescriptor,
} from './descriptor'
export { buildReportOverlayPrimitives } from './overlayPrimitives'
export { getRightGutterWidth } from './overlayLayout'
export { renderReportHeatmapBundle } from './render'
export { createNiceTicks } from './ticks'
export { formatAxisTitle, formatAxisUnit } from './format'
export {
  AxisTickMode,
  OverlayLabelAnchor,
  OverlayLabelPlacement,
  ReportAxisMode,
  ReportComponentOverlayMode,
  ReportLabelMode,
  ReportOverlayMode,
} from './types'
export type {
  ReportHeatmapAxis,
  ReportHeatmapRequestAxisMetadata,
  ReportHeatmapAxisMetadataDescriptor,
  ReportHeatmapCompositeDescriptor,
  ReportHeatmapCompositeSliceDescriptor,
  OverlayLabelPrimitive,
  OverlayLinePrimitive,
  OverlayPrimitives,
  OverlayShapePrimitive,
  ReportHeatmapBundle,
  ReportHeatmapDescriptor,
  ReportHeatmapRequest,
} from './types'
